// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import styled from '@emotion/styled';
import { css } from '@emotion/react';
import {
  spacing,
  fontWeight,
  mediaMax,
  borderRadius,
} from 'presentations/views/styles';
import {
  primary,
  blue03,
  guestPaletone,
  guest,
} from 'presentations/views/styles/color';

interface Props {
  isHost: boolean | null;
  className?: string;
}

export default function Component(props: Props) {
  const t = translateInComponent(translations);
  return (
    <EventRoleTag className={props.className} isHost={props.isHost === true}>
      {t(props.isHost ? 'Host' : 'Guest')}
    </EventRoleTag>
  );
}

export const EventRoleTag = styled.div<{ isHost: boolean }>`
  display: inline;
  background-color: ${blue03};
  border-radius: ${borderRadius(4)};
  color: ${primary};
  padding: ${spacing(4)} ${spacing(20)};
  font-weight: ${fontWeight('bold')};
  ${(props) =>
    !props.isHost &&
    css`
      background-color: ${guestPaletone(props)};
      color: ${guest(props)};
    `}

  ${mediaMax.tablet} {
    padding: ${spacing(3)} ${spacing(6)};
  }
`;
